import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@env/environment';

import { Observable } from 'rxjs';

import { Response, ContractInflation, ContractInflationRequest } from '@core/api';

@Injectable({
  providedIn: 'root'
})
export class ContractInflationService {
  constructor(private http: HttpClient) { }

  get(uuid: string): Observable<Response<ContractInflation>> {
    const headers = new HttpHeaders({ 'content-type': 'application/json' });
    return this.http.post<Response<ContractInflation>>(environment.apiUrl + '/api/ContractInflation/Get', JSON.stringify(uuid), { headers });
  }

  insert(request: ContractInflationRequest): Observable<Response<ContractInflation>> {
    return this.http.post<Response<ContractInflation>>(environment.apiUrl + '/api/ContractInflation/Insert', request);
  }

  update(request: ContractInflationRequest): Observable<Response<ContractInflation>> {
    return this.http.post<Response<ContractInflation>>(environment.apiUrl + '/api/ContractInflation/Update', request);
  }
}
